import {
  Component,
  forwardRef,
  Input
} from '@angular/core';

import {
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS
} from '@angular/forms';
import { InputBaseComponent } from '../base/base.component';

@Component({
  selector: 'jb-input-checkbox',
  templateUrl: './checkbox.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      // tslint:disable-next-line:no-forward-ref
      useExisting: forwardRef(() => InputCheckboxComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      // tslint:disable-next-line:no-forward-ref
      useExisting: forwardRef(() => InputCheckboxComponent),
      multi: true
    }
  ]
})
export class InputCheckboxComponent extends InputBaseComponent {
  protected type: string = 'checkbox';

  @Input()
  public checkboxValue: string | number | boolean = 1;
}



// WEBPACK FOOTER //
// ./src/app/form/input/checkbox/checkbox.component.ts